// extracted by mini-css-extract-plugin
export default {"wrapper":"Header_wrapper__9932Z","title":"Header_title__XOoE2"};